var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React from 'react';
import PropTypes from 'prop-types';

var Icon = function (_React$Component) {
  _inherits(Icon, _React$Component);

  function Icon() {
    _classCallCheck(this, Icon);

    return _possibleConstructorReturn(this, (Icon.__proto__ || Object.getPrototypeOf(Icon)).apply(this, arguments));
  }

  _createClass(Icon, [{
    key: 'render',
    value: function render() {
      var className = 'cf-icon cf-icon--' + this.props.type;

      if (this.props.size) {
        className += ' cf-icon--' + this.props.size;
      }

      if (this.props.border) className += ' cf-icon--border';
      if (this.props.spin) className += ' cf-icon--spin';
      if (this.props.muted) className += ' cf-icon--muted';
      if (this.props.white) className += ' cf-icon--white';

      return React.createElement(
        'i',
        { className: className, role: this.props.role },
        this.props.label && React.createElement(
          'span',
          { className: 'cf-icon__label' },
          this.props.label
        )
      );
    }
  }]);

  return Icon;
}(React.Component);

Icon.propTypes = {
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.oneOf([false])]).isRequired,
  type: PropTypes.oneOf(['bolt', 'calendar', 'caret-down', 'caret-left', 'caret-right', 'caret-up', 'chart', 'chevron-down', 'chevron-left', 'chevron-right', 'chevron-up', 'clipboard', 'close', 'drive', 'exclamation-sign', 'facebook', 'file', 'filter', 'flowchart', 'gear', 'googleplus', 'hamburger', 'happy', 'help', 'info-sign', 'linkedin', 'list', 'loading', 'lock', 'ok', 'ok-sign', 'pause', 'plus', 'refresh', 'remove', 'remove-sign', 'resize-horizontal', 'sad', 'search', 'shield', 'speech', 'time', 'twitter', 'upload', 'widen', 'wrench']).isRequired,
  size: PropTypes.oneOf(['2x', '3x', '4x', 'large', 'xlarge']),
  border: PropTypes.bool,
  spin: PropTypes.bool,
  muted: PropTypes.bool,
  white: PropTypes.bool,
  role: PropTypes.string
};

export default Icon;


//////////////////
// WEBPACK FOOTER
// ./node_modules/cf-component-icon/es/Icon.js
// module id = 803
// module chunks = 0